export default __webpack_public_path__ + "static/media/logo-white.4e8523b6.svg";